import { baseApi } from "./baseApi";

const loansApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLoanDetail: builder.query({
      query: (loanId) => ({
        url: `/loans/${loanId}`,
        method: "GET",
      }),
      providesTags: (result, error, loanId) => [
        { type: "Loan", id: loanId },
      ],
    }),
    patchLoan: builder.mutation({
      query: ({ loanId, data }) => ({
        url: `/loans/${loanId}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    submitLoan: builder.mutation({
      query: (loanId) => ({
        url: `/loans/${loanId}/submit-loan`,
        method: "POST",
      }),
      invalidatesTags: (result, error, loanId) => [
        { type: "Loan", id: loanId },
      ],
    }),
    submitDocOrderRequest: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/doc-order-request`,
        method: "POST",
        body,
      }),
    }),
    importMismo: builder.mutation({
      query: ({ file, loanType, loanChannel, brokerUserId, processorUserId }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("loanType", loanType || "Mortgage");
        formData.append("loanChannel", loanChannel || "Wholesale");
        if (brokerUserId) formData.append("brokerUserId", brokerUserId);
        if (processorUserId) formData.append("processorUserId", processorUserId);
        return {
          url: "/loans/import-mismo",
          method: "POST",
          body: formData,
        };
      },
    }),
    previewMismoAdvisor: builder.mutation({
      query: ({ file, lockTerm, compensationType, productFamilies, terms, confirmedFico, targetPrice }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("lockTerm", String(lockTerm ?? 30));
        formData.append("compensationType", compensationType || "LPC");
        if (productFamilies?.length) {
          formData.append("productFamilies", productFamilies.join(","));
        }
        if (terms?.length) {
          formData.append("terms", terms.join(","));
        }
        if (confirmedFico != null) {
          formData.append("confirmedFico", String(confirmedFico));
        }
        if (targetPrice != null && targetPrice !== '') {
          formData.append("targetPrice", String(targetPrice));
        }
        return {
          url: "/loans/mismo/advisor/preview",
          method: "POST",
          body: formData,
        };
      },
    }),
    recommendMismoAdvisor: builder.mutation({
      query: ({ loanId, ...body }) => ({
        url: `/loans/${loanId}/mismo/advisor/recommend`,
        method: "POST",
        body,
      }),
    }),
    acceptMismoAdvisor: builder.mutation({
      query: ({ loanId, ...body }) => ({
        url: `/loans/${loanId}/mismo/advisor/accept`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    assignProduct: builder.mutation({
      query: ({ loanId, ...body }) => ({
        url: `/loans/${loanId}/pricing/assign-product`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    // One-step assign & lock (pro-api#129). Same body as assign-product; the
    // backend applies pricing and locks the rate in a single call.
    assignAndLockProduct: builder.mutation({
      query: ({ loanId, ...body }) => ({
        url: `/loans/${loanId}/pricing/assign-and-lock`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
  }),
});

export default loansApi;
